import React from 'react';
import { ApiKeyArea } from '../../hooks/useWorkflowApi';

interface KeyAreaFilterBarProps {
  keyAreas: ApiKeyArea[];
  selected: string | null;
  onSelect: (id: string | null) => void;
}

export function KeyAreaFilterBar({ keyAreas, selected, onSelect }: KeyAreaFilterBarProps) {
  const activeKeyAreas = keyAreas.filter((ka) => ka.active);

  return (
    <div style={styles.container}>
      <button
        style={selected === null ? styles.buttonActive : styles.button}
        onClick={() => onSelect(null)}
        type="button"
      >
        All
      </button>
      {activeKeyAreas.map((ka) => (
        <button
          key={ka.id}
          style={selected === ka.id ? styles.buttonActive : styles.button}
          onClick={() => onSelect(ka.id)}
          type="button"
        >
          <span style={styles.icon}>{ka.icon}</span>
          {ka.name}
        </button>
      ))}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    overflowX: 'auto',
    paddingBottom: '8px',
    marginBottom: '16px',
  },
  button: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '6px 14px',
    borderRadius: '9999px',
    border: '1px solid #ccc',
    backgroundColor: '#fff',
    color: '#333',
    fontSize: '14px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  buttonActive: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '6px 14px',
    borderRadius: '9999px',
    border: '1px solid #1a6b3c',
    backgroundColor: '#1a6b3c',
    color: '#fff',
    fontSize: '14px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  icon: {
    flexShrink: 0,
  },
};
